// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card[data-v-6a1325d9] {\n  background-color: var(--magic-tertiary, #311261);\n}\n.card .card[data-v-6a1325d9] {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n@media (min-width: 1024px) {\n  .card .card[data-v-6a1325d9] {\n    box-shadow: none;\n  }\n}\n\n.link[data-v-6a1325d9] {\n  --magic-text-primary: var(--magic-light, #fff);\n}", ""]);
// Exports
module.exports = exports;
